import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CIDRequestDTO, CIDResponseDTO } from '../models/cid.model';

@Injectable({
  providedIn: 'root'
})
export class CidService {

  private baseUrl = environment.trackycontrol + '/api';

  constructor(private http: HttpClient) { }

  createCID(cidData: CIDRequestDTO): Observable<CIDResponseDTO> {
    const token = sessionStorage.getItem('auth_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.post<CIDResponseDTO>(`${this.baseUrl}/cid`, cidData, { headers });
  }

  createCIDcomplete(
    cidData: CIDRequestDTO,
    files: File[],
    vehicleId: number,
    attachmentTypeIds?: (number | undefined)[]
  ): Observable<CIDResponseDTO> {
    const formData = new FormData();

    formData.append('request', JSON.stringify(cidData));

    if (files && files.length) {
      files.forEach((file, index) => {
        formData.append('attachments', file);
        const typeId = attachmentTypeIds?.[index];
        if (typeId != null) {
          formData.append('attachmentTypeIds', String(typeId));
        }
      });
    }

    const token = sessionStorage.getItem('auth_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.post<CIDResponseDTO>(`${this.baseUrl}/cid/complete/${vehicleId}`, formData, { headers });
  }
}